import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API, toast } from '@/App';
import Header from '@/components/layout/Header';
import FooterNew from '@/components/layout/FooterNew';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const NewsletterUnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [searchParams]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      toast.error('Adresse email requise');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/unsubscribe`, {
        email: email.trim(),
        source: 'unsubscribe_page',
      });
      setCompleted(true);
      toast.success('Désinscription enregistrée');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Impossible de traiter la désinscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Header />
      <main className="flex-1">
        <section className="max-w-3xl mx-auto px-4 py-16">
          <Card className="border-red-100 shadow-sm">
            <CardHeader>
              <CardTitle className="text-3xl">Gestion de la newsletter</CardTitle>
              <CardDescription>
                Désabonnez-vous des communications marketing Coli Noki tout en conservant les emails opérationnels nécessaires à vos actions.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              {completed ? (
                <div className="rounded-xl border border-green-200 bg-green-50 p-5">
                  <p className="text-lg font-semibold text-green-800">Votre désinscription a bien été prise en compte.</p>
                  <p className="mt-2 text-sm text-green-700">
                    Votre adresse restera conservée uniquement pour respecter votre choix et éviter de futurs envois marketing non souhaités.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="space-y-2">
                    <Label htmlFor="unsubscribe-email">Adresse email</Label>
                    <Input
                      id="unsubscribe-email"
                      type="email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                      placeholder="vous@exemple.com"
                    />
                  </div>
                  <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
                    Coli Noki continuera uniquement à vous envoyer les notifications strictement nécessaires aux opérations que vous déclenchez sur la plateforme.
                  </div>
                  <div className="flex justify-end">
                    <Button type="submit" disabled={loading}>
                      {loading ? 'Traitement...' : 'Me désinscrire'}
                    </Button>
                  </div>
                </form>
              )}
            </CardContent>
          </Card>
        </section>
      </main>
      <FooterNew />
    </div>
  );
};

export default NewsletterUnsubscribePage;
